import { FeatureFlag } from '@mode/shared/contract-common';
import { HelpDocsService, getAppName, getInitialFlagValue, getOwnerUsername } from '@mode/shared/util-js';
import { ToastService } from '@mode/shared/util-toast';
import * as angular from 'angular';

const username = getOwnerUsername(window.document, true);

class DbInviteInlineFormController implements angular.IController {
  private account: any;
  private email: string;
  private inputRequired: boolean;
  private errorMessage: string;
  private appName = getAppName();

  static $inject = ['AccountModel', 'InviteModel', 'ToastService', 'HelpDocsService'];

  constructor(
    private AccountModel,
    private InviteModel,
    private AlertService: ToastService,
    public helpDocs: HelpDocsService
  ) {}

  $onInit() {
    this.inputRequired = true;

    if (!this.account) {
      this.getAccount(username);
    }
  }

  getAccount(username) {
    this.AccountModel.find({
      username: username,
      useEntryPath: true,
      refresh: true,
      includes: ['new_invite'],
    }).then((account) => {
      this.account = account;
    });
  }

  sendInvite($event: Event) {
    const params = {
      'invite.invitee.email': this.email,
      'invite.message': `A teammate needs your help connecting a database to ${this.appName}. Getting connected is easy, secure, and will allow your team to analyze data, build reports, and share insights instantly.\n\nLearn more about connecting a database: ${this.helpDocs.links['https://mode.com/help/articles/connecting-mode-to-your-database']}\n\nClick below to accept your invite and connect a database to ${this.appName}:`,
      'invite.internal_source': 'database_connection',
    };

    this.InviteModel.create({
      account: this.account.username,
      params,
    })
      .then(() => {
        this.AlertService.success('Invite sent');
        this.email = ''; // clear form
        this.errorMessage = ''; // clear errors
        this.inputRequired = false;
      })
      .catch((err) => {
        this.AlertService.error('Failed to send invite');
        if (err.status === 400) {
          this.errorMessage = err.data.message;
        } else if (err.status === 500) {
          this.errorMessage = 'Failed to send invite. Please try again.';
        }
      });

    const input = (<Element>$event.target).querySelector('input');
    input.blur();
  }
}

const DbInviteInlineFormComponent: angular.IComponentOptions = {
  controller: DbInviteInlineFormController,
  controllerAs: 'ctrl',
  bindings: {
    account: '<?',
    email: '<',
  },
  template: `
    <form name="dbInviteForm" id="dbInviteForm" class="form-horizontal" ng-submit="ctrl.sendInvite($event)">
      <div class="form-group">
        <div class="input-group">
          <input type="email" class="form-control mode-input"
                 placeholder="Enter an email..."
                 maxlength="255"
                 ng-class="{'ng-invalid':ctrl.errorMessage.length}"
                 ng-required="ctrl.inputRequired"
                 ng-model="ctrl.email">
          <span class="input-group-btn">
            <capra-button class="action-button save" type="submit" text="Invite"></capra-button>
          </span>
        </div>

        <div class="form-control-error" ng-cloak>
          <div ng-show="ctrl.errorMessage.length">{{ ctrl.errorMessage }}</div>
        </div>

      </div>
    </form>
  `,
};

angular.module('mode.components').component('dbInviteInlineForm', DbInviteInlineFormComponent);
